import { render } from "./FormTBTHSuccess.vue?vue&type=template&id=0338a07a&scoped=true"
import script from "./FormTBTHSuccess.vue?vue&type=script&lang=js"
export * from "./FormTBTHSuccess.vue?vue&type=script&lang=js"

import "./FormTBTHSuccess.vue?vue&type=style&index=0&id=0338a07a&lang=scss&scoped=true"

import exportComponent from "/DATA/REPO/survey-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0338a07a"]])

export default __exports__